import { BusinessApi } from 'shared/api';
import { IBusinessInfoDto } from 'shared/api/business/interfaces/business-info-dto.interface';
import { IGetBusinessesDto } from 'shared/api/business/interfaces/get-businesses-dto.interface';

export const getOwnerBusinesses = async (): Promise<IBusinessInfoDto[]> => {
  const ownerId: IGetBusinessesDto = await BusinessApi.getAccountInfo();
  return BusinessApi.getBusinessesInfo(ownerId);
};
